import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <span> & </span>
        <a
          className="App-link"
          href="https://www.cloudflare.com"
          target="_blank"
          rel="noopener noreferrer"
          >
          Deploy on Cloudflare and say hi to Niklas.
        </a>
      </header>
    </div>
  );
}

export default App;
